import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommArrowDownIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M6.24115 14.6982C5.94826 14.9911 5.94826 15.466 6.24115 15.7588L10.534 20.0517C10.5421 20.0598 10.5502 20.0679 10.5584 20.0761C10.7034 20.2212 10.8601 20.3781 11.0103 20.4927C11.1863 20.6269 11.438 20.7714 11.7715 20.7714C12.105 20.7714 12.3567 20.6269 12.5326 20.4927C12.6828 20.3781 12.8396 20.2212 12.9846 20.0761C12.9927 20.0679 13.0008 20.0598 13.0089 20.0517L17.3018 15.7588C17.5947 15.466 17.5947 14.9911 17.3018 14.6982C17.0089 14.4053 16.534 14.4053 16.2412 14.6982L11.9483 18.9911C11.8782 19.0611 11.8214 19.1179 11.7715 19.1662C11.7216 19.1179 11.6648 19.0611 11.5947 18.9911L7.30181 14.6982C7.00892 14.4053 6.53405 14.4053 6.24115 14.6982Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M11.7715 20.2285C12.1857 20.2285 12.5215 19.8927 12.5215 19.4785L12.5215 3.97852C12.5215 3.5643 12.1857 3.22852 11.7715 3.22852C11.3573 3.22852 11.0215 3.5643 11.0215 3.97852L11.0215 19.4785C11.0215 19.8927 11.3573 20.2285 11.7715 20.2285Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
